var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General / diamond"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.75 7.5H2.25M7.875 3.75L6.75 7.5L9 15L11.25 7.5L10.125 3.75M2.64894 7.94327L8.44253 14.3806C8.74046 14.7116 9.25954 14.7116 9.55747 14.3806L15.3511 7.94327C15.5846 7.68377 15.6082 7.29745 15.408 7.01145L13.3489 4.0699C13.2086 3.86941 12.9792 3.75 12.7345 3.75H5.26549C5.02076 3.75 4.79141 3.86941 4.65107 4.0699L2.59199 7.01145C2.39178 7.29745 2.4154 7.68377 2.64894 7.94327Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.08e986660a1141fb88a305afdd22e2cf.svg";
export { ForwardRef as ReactComponent };